import { useEffect, useState } from "react";
import { Button, Grid, Typography } from "@mui/material";
import CashlessEconomyPOSDataTable from "./dataTable";
import { Paper } from "@mui/material";
import CashlessEconomyPOSCreate from "./create";
import { pos_getAll } from "../../../../../../controllers/company/cashless/PosController";

export default function CashlessEconomyPOS({economy})
{
    const [pos,setPos] = useState([]);
    const [participants,setParticipants] = useState([]);

    useEffect(()=>{
        handleGetPos();
    },[]);

    const handleGetPos = async () => {
        const response = await pos_getAll(economy.id);
        if(response.success === true)
        {
            setPos(response.data.pos);
            setParticipants(response.data.participants);
        }
    }
    
    const onUpdate = async () => {

    }

    return(
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <CashlessEconomyPOSCreate economy={economy} participants={participants} onUpdate={()=>onUpdate()}/>
            </Grid>
            <Grid item xs={12}>
                <CashlessEconomyPOSDataTable pos={pos} />
            </Grid>
        </Grid>
    )
}